import { toast } from '@/lib/toasts/api'

const collectLines = (payload: unknown, code: string): string[] => {
  const notices = Array.isArray(payload) ? payload : payload ? [payload] : []
  return notices
    .filter((notice: any) => notice?.code === code && notice?.message)
    .flatMap((notice: any) => String(notice.message).split(/\r?\n/))
    .map((line) => line.trim())
    .filter(Boolean)
}

// "Nazwisko Imie|dd.MM.yyyy" -> "Nazwisko Imie (26 lat: dd.MM.yyyy)"; bez daty zostaje samo nazwisko.
const withAgeLimitDate = (line: string, t: (key: string) => string) => {
  const [name, ageLimitDate] = line.split('|').map((part) => part?.trim())
  return ageLimitDate
    ? `${name} (${t('timesheet.tax-exempt-age-limit')}: ${ageLimitDate})`
    : name
}

/**
 * Informacje z precalculate o uldze dla mlodych - niczego nie blokuja.
 * UNDER_26_MISSING: ponizej 26 lat bez ulgi - odznaczone pole moze oznaczac wniosek
 * pracownika o niestosowanie ulgi, wiec przeliczenia nie wstrzymujemy.
 * EXPIRED: ulga zaznaczona po 26 latach - silnik jej nie nalicza.
 * AGE_UNKNOWN: ulga zaznaczona, ale bez daty urodzenia/PESEL-u silnik nie sprawdzi 26 lat.
 */
const TAX_EXEMPT_NOTICES = [
  {
    code: 'TIMESHEET_TAX_EXEMPT_UNDER_26_MISSING',
    titleKey: 'timesheet.tax-exempt-under-26-missing-title',
    textKey: 'timesheet.tax-exempt-under-26-missing',
  },
  {
    code: 'TIMESHEET_TAX_EXEMPT_EXPIRED',
    titleKey: 'timesheet.tax-exempt-expired-title',
    textKey: 'timesheet.tax-exempt-expired',
  },
  {
    code: 'TIMESHEET_TAX_EXEMPT_AGE_UNKNOWN',
    titleKey: 'timesheet.tax-exempt-age-unknown-title',
    textKey: 'timesheet.tax-exempt-age-unknown',
  },
]

export const notifyTaxExemptNotices = (
  payload: unknown,
  t: (key: string) => string,
) => {
  TAX_EXEMPT_NOTICES.forEach(({ code, titleKey, textKey }) => {
    const drivers = collectLines(payload, code).map((line) =>
      withAgeLimitDate(line, t),
    )
    if (drivers.length === 0) return

    toast.warning({
      title: t(titleKey),
      text: `${drivers.join(', ')} ${t(textKey)}`,
      autoCloseMs: 15000,
    })
  })
}
